'use client';
import { Container, Heading, Text, VStack } from '@chakra-ui/react';
import { useI18nLn } from '~/hooks/store';

export const NotFoundPage = () => {
  const { t } = useI18nLn();

  return (
    <Container flexDirection="column" maxW="lg" textAlign="center">
      <VStack width="full">
        <Heading fontSize="4xl" p={6} textAlign="center">
          404
        </Heading>
        <Text p={4} fontSize="lg">
          {t('errors.not_found.title')}
        </Text>
        <Text p={4}>{t('errors.not_found.description')}</Text>
      </VStack>
    </Container>
  );
};
